module.exports = __webpack_public_path__ + "img/buyer-support.1435a24d.png";